import React from "react";
import i18n from "../../constants/i18n";
import getUserStore from "../../stores/user-store";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import Et3Picker from "../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../TypesNEW";

const UserSearchPlatForm = withLiteObserverAndTheme<{ withPlatform: boolean }>(
  (props) => {
    const { withPlatform } = props;

    return withPlatform ? (
      <React.Fragment>
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("PLATFORM")}
          options={[
            { label: "android", value: "ANDROID" },
            { label: "ios", value: "IOS" }
          ]}
          onChoose={(value: TEt3PickerSingleValue) => {
            getUserStore().setUserPlatformInput(value);
          }}
          value={getUserStore().userPlatformInput.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </React.Fragment>
    ) : null;
  }
);
export default UserSearchPlatForm;
